/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DemandeFormationGridDto
 */
export interface DemandeFormationGridDto {
    /**
     * 
     * @type {number}
     * @memberof DemandeFormationGridDto
     */
    iddemandeFormationCrea?: number;
    /**
     * 
     * @type {number}
     * @memberof DemandeFormationGridDto
     */
    idmetier?: number;
    /**
     * 
     * @type {string}
     * @memberof DemandeFormationGridDto
     */
    metier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DemandeFormationGridDto
     */
    idmodule?: number;
    /**
     * 
     * @type {string}
     * @memberof DemandeFormationGridDto
     */
    module?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeFormationGridDto
     */
    idannee?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeFormationGridDto
     */
    annee?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DemandeFormationGridDto
     */
    premierSemestre?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof DemandeFormationGridDto
     */
    idcentre?: number;
    /**
     * 
     * @type {string}
     * @memberof DemandeFormationGridDto
     */
    centre?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DemandeFormationGridDto
     */
    idstatutDemande?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DemandeFormationGridDto
     */
    editable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DemandeFormationGridDto
     */
    remarqueInvalidation?: string | null;
}

/**
 * Check if a given object implements the DemandeFormationGridDto interface.
 */
export function instanceOfDemandeFormationGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DemandeFormationGridDtoFromJSON(json: any): DemandeFormationGridDto {
    return DemandeFormationGridDtoFromJSONTyped(json, false);
}

export function DemandeFormationGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemandeFormationGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iddemandeFormationCrea': !exists(json, 'iddemandeFormationCrea') ? undefined : json['iddemandeFormationCrea'],
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'metier': !exists(json, 'metier') ? undefined : json['metier'],
        'idmodule': !exists(json, 'idmodule') ? undefined : json['idmodule'],
        'module': !exists(json, 'module') ? undefined : json['module'],
        'idannee': !exists(json, 'idannee') ? undefined : json['idannee'],
        'annee': !exists(json, 'annee') ? undefined : json['annee'],
        'premierSemestre': !exists(json, 'premierSemestre') ? undefined : json['premierSemestre'],
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'centre': !exists(json, 'centre') ? undefined : json['centre'],
        'idstatutDemande': !exists(json, 'idstatutDemande') ? undefined : json['idstatutDemande'],
        'editable': !exists(json, 'editable') ? undefined : json['editable'],
        'remarqueInvalidation': !exists(json, 'remarqueInvalidation') ? undefined : json['remarqueInvalidation'],
    };
}

export function DemandeFormationGridDtoToJSON(value?: DemandeFormationGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iddemandeFormationCrea': value.iddemandeFormationCrea,
        'idmetier': value.idmetier,
        'metier': value.metier,
        'idmodule': value.idmodule,
        'module': value.module,
        'idannee': value.idannee,
        'annee': value.annee,
        'premierSemestre': value.premierSemestre,
        'idcentre': value.idcentre,
        'centre': value.centre,
        'idstatutDemande': value.idstatutDemande,
        'editable': value.editable,
        'remarqueInvalidation': value.remarqueInvalidation,
    };
}

